import React, { Component } from "react";
import swal from "sweetalert";
import endPoint from "../../../config";
import axios from "../../../httpServices/httpService";
import valid from '../../../utill/validation';
import joi from 'joi';
import Loading from "../../../utill/LoadingComponent";
import MultiSelect from "../../../Common/multiselect";


class ToolCodeMaster extends Component {
  state = {
    toolMaster: {},
    oldObj: {},
    equipmentTypeList: [],
    equipmentList:[],
    errors:{},
    querySuccess:false,
    cycleTimeRadioState:1,
  };

  schema={
    ToolCode:joi.string().required().label('Tool Code'),
    Equipment:joi.string().required().label('Equipment'),
    //ScrapWeightCycle:joi.number().required().min(0).label('Scrap Weigth Cycle'),
    DeviceId:joi.string().required(),
    

  }


  componentDidMount() {
    this.setState({querySuccess:true});
    axios
      .get(endPoint.dataEntryUrl + "equipment")
      .then(result => {
        this.setState({ equipmentList: result.data,querySuccess:false });
      })
      .catch(err => {
        this.setState({querySuccess:false});
        swal(`${err}`);
      });

    if (this.props.actionStatus === "add") {
      this.setState({ toolMaster: {} });
    }
    if (this.props.actionStatus === "update") {
      const toolMaster = { ...this.props.toolCodeData };
      let radioState;
      if(toolMaster.CyclePerParts)
      radioState=0;
      
      if(toolMaster.PartsPerCycle)
      radioState=1;
      console.log(toolMaster)
      this.setState({
        toolMaster: this.props.toolCodeData,
        oldObj: toolMaster,
        cycleTimeRadioState:radioState
      });
    }
  }

  getDate = datetime => {
    if (datetime) {
      let date = new Date(datetime);
      return (
        date.getFullYear() +
        "-" +
        ((date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1)) +
        "-" +
        ((date.getDate() < 10 ? "0" : "") + date.getDate())
      );
    }
  };

  handleOnChange = e => {
    const { toolMaster,errors } = { ...this.state };
    const errorMessage = valid.validateProperty(e.currentTarget,this.schema);
    if (errorMessage) errors[e.currentTarget.name] = errorMessage;
    else delete errors[e.currentTarget.name];
    toolMaster[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ toolMaster,errors:errors||{} });
    console.log(toolMaster);
  };
  handleSubmit = data => {
   

  
      if (this.props.actionStatus === "add") {
        const errors = valid.validate(data,this.schema);
        console.log(errors)
        this.setState({ errors: errors || {} });
        if (errors) return;

        this.setState({querySuccess:true});
        axios
          .post(endPoint.dataEntryUrl + "toolCode", data)
          .then(result => {
            if (result.status===200) {
              this.setState({querySuccess:false});
              this.props.history.push("/setting/toolCode/list");
              swal("Save Data Successfully");
            } else {
              this.setState({querySuccess:false});
              swal(`Data Not Saved`);
            }
          })
          .catch(err => {
            this.setState({querySuccess:false});
            swal(`${err.response.data.message}`);
          });
      }
      if (this.props.actionStatus === "update") {
        this.setState({querySuccess:true});
        axios
          .patch(endPoint.dataEntryUrl + "toolCode/"+data._id, {
            old: this.state.oldObj,
            new: data
          })
          .then(result => {
            const { n, nModified, ok } = result.data;
            if (ok == 1 && n == 1 && nModified == 1) {
              this.setState({querySuccess:false});
              this.props.history.push("/setting/toolCode/list");
              swal("Update Data Successfully");
            } else {
              this.setState({querySuccess:false});
              swal(`${result.data}`);
            }
          })
          .catch(err => {
            this.setState({querySuccess:false});
            swal(`${err.response.data.message}`);

          });
      }
  
  };
  handleRadioChange = (e) => {
    //const { component } = { ...this.state };
    //const { Operation } = { ...this.state };
    const { name, value } = e.currentTarget;

    
    if (name === "CycleTime") {
      this.setState({
        [name]: value === "PPC" ? 1 : 0,
        cycleTimeRadioState: value === "CPP" ? 0 : 1
      });
    }
  };

  render() {
    return (
      <React.Fragment>
      {this.state.querySuccess?<Loading/>:''}
      
        <div className=" border">
          <div className="row justify-content-center">
            <div className="col-sm-4 ">
              <div className="form-group text-center">
                <label>Tool Code</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Tool Code"
                  name="ToolCode"
                  onChange={this.handleOnChange}
                  defaultValue={this.state.toolMaster.ToolCode}
                />
                {this.state.errors.ToolCode && <div className="alert small alert-danger">{this.state.errors['ToolCode']}</div>}
              </div>
            </div>

            <div className="col-sm-4 ">
            <div className="form-group text-center">
                <label>Equipment</label>
                {/* <select
                  type="text"
                  className="form-control"
                  name="EquipmentType"
                  onChange={this.handleOnChange}
                  value={this.state.toolMaster.EquipmentType}
                >
                  <option>--select equipment type--</option>
                  {this.state.equipmentTypeList.map((one,i) => {
                    return <option key={i}>{one.EquipmentType}</option>;
                  })}
                </select> */}
                    <MultiSelect name="Equipment" selected={this.state.toolMaster['Equipment']} handleOnChange={this.handleOnChange} masterName="EquipmentID" objLevel={1} all={this.state.equipmentList}/>

                {this.state.errors.Equipment && <div className="alert small alert-danger">{this.state.errors['Equipment']}</div>}
              </div>
            </div>

            <div className="col-sm-4 ">
              <div className="form-group text-center">
                <label>Device ID</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="DeviceId"
                  name="DeviceId"
                  onChange={this.handleOnChange}
                  defaultValue={this.state.toolMaster.DeviceId}
                />
                {this.state.errors.DeviceId && <div className="alert small alert-danger">{this.state.errors['DeviceId']}</div>}
              </div>
            </div>
           
           
          </div>
          <div className="text-center">
            <button
              className="btn btn-primary"
              onClick={() => {
                this.handleSubmit(this.state.toolMaster);
              }}
            >
              Submit
            </button>
          </div>
          <div className="text-center" style={{ marginTop: 10 }}>
            <button
              className="btn btn-primary"
              onClick={() => {
                this.props.history.push("/setting/toolCode/list");
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ToolCodeMaster;
